import { Checkmark } from "./Checkmark";

export default Checkmark;
